"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGamePlayer = useGamePlayer;
exports.usePlayerRank = usePlayerRank;
exports.useLocalPlayer = useLocalPlayer;
exports.useOpponentPlayer = useOpponentPlayer;
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const context_1 = require("~/auth/context");
function useGamePlayer(id) {
    return (0, react_redux_1.useSelector)((state) => id ? state.game.players.find((p) => p.id === id) : undefined);
}
function usePlayerRank(id) {
    return (0, react_redux_1.useSelector)((state) => state.game.players.findIndex((p) => p.id === id) + 1);
}
/**
 * The local Player joined with the local-only extras (xp, matchRewards,
 * opponentId, opponentIsClone). Returns null until the first
 * playerListChangedEvent arrives.
 */
function useLocalPlayer() {
    const accountId = (0, context_1.useAccountId)();
    const player = useGamePlayer(accountId);
    const extras = (0, react_redux_1.useSelector)((state) => ({
        xp: state.game.localPlayer.xp,
        matchRewards: state.game.localPlayer.matchRewards,
        opponentId: state.game.localPlayer.opponentId,
        opponentIsClone: state.game.localPlayer.opponentIsClone,
    }));
    const result = (0, react_1.useMemo)(() => {
        if (!player) {
            return null;
        }
        return Object.assign(Object.assign({}, player), extras);
    }, [player, extras]);
    return result;
}
function useOpponentPlayer() {
    const opponentId = (0, react_redux_1.useSelector)((state) => state.game.localPlayer.opponentId);
    return useGamePlayer(opponentId);
}
